import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { number_format } from "Utils";
import { SvgIcon } from "../../Common/Icons";
import _ from "i18n";
import ComponentActions from "./ComponentActions";

class IllustrativeIconAndValueComponent extends Component {
  render() {
    const {
      slideId,
      isPreparePresentation,
      component,
      isPresentation,
      hasComments,
      isComposition,
      indicatorsExplanation,
      hasExplanation
    } = this.props;

    const {
      componentId,
      labels,
      data: { account },
      config: { icon, annexeAttachmentCategory }
    } = component;

    const {
      percentage,
      currentValue,
      diffValue,
      unit,
      notAvailable
    } = account[0];

    return (
      <div>
        <ComponentHeader
          slideId={slideId}
          percentage={percentage}
          title={labels}
          annexeAttachmentCategory={annexeAttachmentCategory}
          handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
          isComposition={isComposition}
          isPresentation={isPresentation}
          hasComments={hasComments}
          componentId={componentId}
          isPreparePresentation={isPreparePresentation}
          indicatorsExplanation={indicatorsExplanation}
          hasExplanation={hasExplanation}
          inSlideView={this.props.inSlideView}
        />
        <div
          className={classnames(
            styles.IllustrativeIconAndValueComponent,
            styles.absolute_container,
            styles.flex_container,
            styles.align_container
          )}
        >
          {!this.props.inSlideView &&
            !this.props.isEmbedded && (
              <ComponentActions
                removeComponent={this.props.handleRemoveComponent}
                updateComponent={this.props.handleUpdateComponent}
                componentCase={this.props.ComponentCase}
                sideBar={"ComponentConfig"}
                component={"IllustrativeIconAndValueComponent.png"}
              />
            )}
          <span
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
          >
            <SvgIcon
              icon={icon ? icon : "DollarMoneyBagWithCoinStacks"}
              className={classnames(
                styles.lighter_opacity,
                percentage > 0 ? styles.smaller_icon : styles.bigger_icon
              )}
            />
            <SvgIcon icon={"ThreeDots"} className={styles.three_dots} />
            <SvgIcon
              icon={icon ? icon : "DollarMoneyBagWithCoinStacks"}
              className={classnames(
                styles.thicker_opacity,
                percentage < 0 ? styles.smaller_icon : styles.bigger_icon
              )}
            />
          </span>

          <div
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
          >
            <span
              className={classnames(
                "medium-12 small-12",
                styles.sub_value,
                percentage > 0 ? styles.positive_value : styles.negative_value
              )}
            >
              {notAvailable
                ? _("notAvailable")
                : percentage > 0
                  ? _("increaseOf")
                  : _("decreaseOf")}{" "}
              <span className={styles.positive_value}>
                {notAvailable ? "" : number_format(diffValue, 2, ",", " ")}{" "}
                {unit !== "none" ? unit : ""}
              </span>
            </span>
            <span
              className={classnames("medium-12 small-12", styles.main_value)}
            >
              {notAvailable
                ? currentValue
                : number_format(currentValue, 2, ",", " ")}{" "}
              {unit !== "none" ? unit : ""}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default IllustrativeIconAndValueComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/IllustrativeIconAndValueComponent.js